import React from 'react';
import { Field, ErrorMessage, useFormikContext } from 'formik';
import styled from 'styled-components';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectFieldProps {
  label: string;
  name: string;
  value: string;
  options: SelectOption[];
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  isRequired?:boolean;
  placeholder?: string;
}

const FieldContainer = styled.div`
  // margin: 1rem 0;           
  font-family: "Poppins", sans-serif;
  margin: .300rem 0;
`;

const StyledLabel = styled.label`
  display: block;
  // margin-bottom: 0.25rem;
  margin-bottom: 1px;
  font-weight: 600;
`;

const StyledError = styled.div`
  color: red;
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;

const StyledSelect = styled.select`
  padding: 0.5rem;
  width: 100%;
  box-sizing: border-box;
   appearance: none;
  background-color: white;
  border: 1px solid #ccc;
  cursor: pointer;
  border-radius: 5px;
  line-height: 20px;
  outline: none;
  /* dropdown custom arrow*/
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="gray"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  &:focus,
  &:focus-visible {
    border-color: #007bff !important;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5) !important;
    outline: none;
  }

`;

export const SelectField: React.FC<SelectFieldProps> = ({ label, name, value, options, onChange, isRequired=false }) => {
  const { setFieldValue,setFieldTouched } = useFormikContext();
  
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFieldValue(name, e.target.value); 
    if (onChange) {
      onChange(e); 
      setFieldTouched(`${name}`, true);
    }
  };

  return (
    <FieldContainer>
      <StyledLabel htmlFor={name}>{label}{isRequired&&<span style={{ color: "red", fontSize: "15px" }}>*</span>}</StyledLabel>
      <StyledSelect id={name} name={name} value={value} onChange={handleChange}
              onBlur={() => setFieldTouched(`${name}`, true)}
      >
        <option value="">Select an option...</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </StyledSelect>
      <ErrorMessage name={name} component={StyledError} />
    </FieldContainer>
  );
};
